import { render } from "./index.vue?vue&type=template&id=3081894e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3081894e&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\TraCuuVe_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3081894e"]])

export default __exports__